<script lang="ts">
	import {
		Stack,
		AdvancedCard,
		LabelList,
		AdvancedCardV2,
		// ListItem,
		// ControlsContainer
	} from '@Shelly/shelly-design-system';
	import DeviceInList from '../Lists/Devices/DeviceInList.svelte';
	import { getDeviceInGroup } from 'src/helpers/group_helpers';
	import DeviceStateSlot from '../Lists/Devices/DeviceStateSlot.svelte';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let devices;
</script>

<!-- <ControlsContainer>
	<svelte:fragment slot="first"> -->
<Stack gap="s">
	{#each devices as device (device.id)}
		<DeviceStateSlot deviceId={device.id} let:hasDeviceState>
		{#if !hasDeviceState}
			{#if $showNewLayout}
				<AdvancedCardV2
					isCondensed
					title={$format('missing_device_label', { default: 'Missing Device' })}
					avatar={{
						icon: 'text-warning fas fa-warning',
					}}
				>
					<svelte:fragment slot="main">
						<LabelList labelList={[{ value: device?.id, icon: 'fa-solid fa-microchip' }]} />
					</svelte:fragment>
				</AdvancedCardV2>
			{:else}
				<AdvancedCard
					isCondensed
					title={$format('missing_device_label', { default: 'Missing Device' })}
					avatar={{
						icon: 'text-warning fas fa-warning',
					}}
				>
					<svelte:fragment slot="main">
						<LabelList labelList={[{ value: device?.id, icon: 'fa-solid fa-microchip' }]} />
					</svelte:fragment>
				</AdvancedCard>
			{/if}
		{:else}
			<DeviceInList device={getDeviceInGroup(device)} type={'group'} />
		{/if}
		</DeviceStateSlot>

		<!-- <ListItem
					title={device.name}
					image={device.image}
					subtitle={$rooms[device?.room_id]?.name}
				/> -->
	{/each}
</Stack>
<!-- </svelte:fragment>
</ControlsContainer> -->
